export default __webpack_public_path__ + "static/media/mobile-push-notifications.d5481b0b.jpg";